export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fb9bcb30e957c05f5d11ff0767a7817e9de0624d0&name=fetchTypeahead!'